import { LenderResult } from "@src/apis/ModularClient";

export class DeveloperExitFinanceResultController {
  selectedSection: string;

  //objects: DeveloperExitFinanceResult[];
  selectedObject: any; //DeveloperExitFinanceResult

  exitLoanCriteria: any; //Changed from DeveloperExitFinanceInputSet to any, change back if used.

  results: any; //Changed from DeveloperExitFinanceResultSet to any, change back if used.

  matchingResults: any[]; //DeveloperExitFinanceResult
  largestResults: any[]; //DeveloperExitFinanceResult

  comparisonList: any[] = []; //DeveloperExitFinanceResult

  selectedResult: any; //DeveloperExitFinanceResult

  warningOff: boolean = false;

  enquiryOpen: boolean;
  enquiryEmail: string;
  enquiryBody: string;
  enquiryTelephone: string;
  sentmessage: boolean = false;
  sendingmessage: boolean = false;

  fetchingObjects: boolean;
  fetchingObject: boolean;

  developerexitfinanceresultForm: ng.IFormController;

  static $inject = ["$rootScope", "$location", "$routeParams"];

  constructor(
    private $rootScope: ng.IRootScopeService,
    private $location: ng.ILocationService,
    $routeParams: ng.route.IRouteParamsService,
  ) {
    this.updateObjects();
  }

  updateObjects() {
    this.fetchingObjects = true;
    this.exitLoanCriteria = (this.$rootScope as any).exitLoanCriteria;
    this.updateResults();
  }

  updateResults() {
    // this.developerExitFinanceResultClient.ProductsOfferingLargestLoanAndMatching(
    //     this.exitLoanCriteria,
    //     true,
    //     true,
    //     20,
    //     false,
    //     "",
    //     "",
    //     "",
    //     "",
    //   )
    //   .then((results) => {
    //     this.results = results;
    //     this.matchingResults = results.MatchingResults;
    //     this.largestResults = results.LargestLoanResults;
    //   })
    //   .catch((error) => {
    //     this.matchingResults = [];
    //   })
    //   .finally(() => {});
  }

  sendEnquiry(): void {
    this.sendingmessage = true;
    this.sentmessage = false;

    // this.developerExitFinanceResultClient.ProductsOfferingLargestLoanAndMatching(
    //     this.exitLoanCriteria,
    //     true,
    //     true,
    //     20,
    //     true,
    //     this.enquiryBody,
    //     this.enquiryEmail,
    //     this.enquiryTelephone,
    //     this.GetSelectedLabel(),
    //   )
    //   .then((response2) => {
    //     this.sendingmessage = false;
    //     this.sentmessage = true;
    //   });
  }

  private GetSelectedLabel() {
    var selectedlabel = "";
    if (this.selectedResult && this.selectedResult.loanLabel) {
      selectedlabel = this.selectedResult.loanLabel;
    }
    return selectedlabel;
  }

  comparisonContains(item: any) {
    let found = !!this.comparisonList.find((result, index) => {
      return result === item;
    });

    if (found) {
    }

    return found;
  }

  toggleLenderComparisonSelection(item: any) {
    let match: any = this.comparisonList.find((result, index) => {
      return result === item;
    });

    if (!match && this.comparisonList.length < 3) {
      this.comparisonList.push(item);
    } else {
      this.comparisonList.splice(this.comparisonList.indexOf(match), 1);
    }
  }

  viewOffer(offer: any) {
    this.selectedResult = offer;
  }

  goCompare() {
    this.warningOff = true;
    (this.$rootScope as any).comparisonList = this.comparisonList;

    // temporarily put all results into saved results so the comparison controller can use them.

    let allResults: any[] = [];
    this.matchingResults.forEach((result) => {
      allResults.push(result);
    });
    this.largestResults.forEach((result) => {
      allResults.push(result);
    });

    (this.$rootScope as any).tempSavedResults = allResults;

    this.$location.path("exitloancompare");
  }

  viewSingleLoan(item: any) {
    this.warningOff = true;
    this.comparisonList = [];
    this.comparisonList.push(item);
    this.goCompare();
  }
  go(path): void {
    this.$location.path(path);
  }

  applyForLoan(offer: any, index) {
    this.selectedResult = offer;
    this.enquiryBody = "Please call me about loan: " + offer.loanLabel;
    this.enquiryOpen = true;
  }
}
